export interface CurrencyConfig {
  id: string;
  name: string;
  symbol: string;
  icon: string;
  chain: 'ton' | 'erc20' | 'trc20' | 'solana';
  decimals: number;
  minBet: number;
  maxBet: number;
  minDeposit: number;
  minWithdraw: number;
  withdrawFee: number;
  color?: string;
  usdRate?: number;
}

export const CURRENCIES: Record<string, CurrencyConfig> = {
  usdt: {
    id: 'usdt',
    name: 'USDT',
    symbol: '$',
    icon: '🪙',
    chain: 'trc20', // 可配置多链支持，默认设为主力的 trc20
    decimals: 2,
    minBet: 0.1,
    maxBet: 500,
    minDeposit: 1,
    minWithdraw: 5,
    withdrawFee: 0.5,
    color: '#26A17B',
    usdRate: 1.0,
  },
  trx: {
    id: 'trx',
    name: 'TRX',
    symbol: 'TRX',
    icon: '💎',
    chain: 'trc20',
    decimals: 2,
    minBet: 1.0,
    maxBet: 5000,
    minDeposit: 10,
    minWithdraw: 50,
    withdrawFee: 2.0,
    color: '#EC0623',
    usdRate: 0.12, // 初始预设，后续由 price-service 动态更新
  },
  ton: {
    id: 'ton',
    name: 'TON',
    symbol: 'TON',
    icon: '💎',
    chain: 'ton',
    decimals: 2,
    minBet: 0.05,
    maxBet: 100,
    minDeposit: 0.5,
    minWithdraw: 1.0,
    withdrawFee: 0.05,
    color: '#0098EA',
    usdRate: 7.2,
  },
  eth: {
    id: 'eth',
    name: 'ETH',
    symbol: 'ETH',
    icon: 'Ξ',
    chain: 'erc20',
    decimals: 6, // ⚠️ 必须用 6 位或更高，绝对不能用 2 位，防止高精度代币归零
    minBet: 0.0001,
    maxBet: 0.5,
    minDeposit: 0.001,
    minWithdraw: 0.005,
    withdrawFee: 0.001,
    color: '#627EEA',
    usdRate: 3500,
  },
};

/**
 * 智能金额格式化函数 - 杜绝 0.0015 ETH 被 toFixed(2) 截断为 0.00 的 P0 级 Bug
 * @param amount 金额
 * @param currency 币种 ID
 */
export function fmtAmt(amount: number, currency: string): string {
  const cfg = CURRENCIES[currency];
  if (!cfg) return amount.toFixed(2);

  if (cfg.decimals <= 2) {
    return amount.toFixed(2);
  }

  // 精度大于 2 位的代币 (如 ETH)，保留全部精度后去除尾部无用的零，但至少保留 2 位小数
  const formatted = amount.toFixed(cfg.decimals);
  return formatted.replace(/(\.\d{2}(?:\d*[1-9])?)0+$/, '$1');
}

/**
 * 精度安全的计算倍率
 * 规则：所有涉及金额计算的精度修正，必须使用 1e6，不能使用 100 截断
 */
export const PRECISION_MULTIPLIER = 1e6;

export function safeRound(amount: number): number {
  return Math.round(amount * PRECISION_MULTIPLIER) / PRECISION_MULTIPLIER;
}
